<template>
  <mdb-container style="margin-top: 6em">
    <section class="text-justify text-monospace my-5">
      <h2 class="h1-responsive font-weight-bold my-5 text-center">加拿大曼省留学移民</h2>
      <p class="w-responsive mx-auto mb-5">
        <span class="mr-4"></span>

        2017年11月15日曼省移民局公布了最新的留学工作转移民项目，可通过新政下的国际教育类别（International Education Stream）进行申请移民，申请人在过去的三年内从曼省认可的学习机构获得至少1年学制的包括两个学期的全日制教育毕业证，即可符合递交移民的最基本资格。和以往相比较，不用等待工作满6个月后才递交移民申请，大大缩短了申请人的时间。

      </p>
      <mdb-row class="">
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/ca/1.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">申请要求</h4>
            <p>1、年龄在18-45岁之间；</p>
            <p>2、高中或中专以上学历；</p>
            <p>3、具有一定的英文水平；</p>
          </mdb-card-body>
        </mdb-col>
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/ca/7.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">项目优势</h4>
            <p>1. 整体花费低，约40万人民币；</p>
            <p>2. 学习期间设立监护服务，监督学生、保证每个阶段学生顺利过关、完成学业；</p>
            <p>3. 保证工作机会，确保曼省省政府递交移民的资格，从而获得枫叶卡；</p>
            <p>4. 整体申请时间较快，拿到枫叶卡约1年半左右：
              ①单身可以读书1年后工作半年移民；
              ②已婚可以夫妻配合移民，工作6个月直接移民；
              ③外省留学生毕业的可以到曼省工作一年移民。
            </p>
            <p>
              5. 最快3个月登陆加拿大后，配偶可办理开放式工签，孩子可免费在曼省读书。
            </p>
            <p>
              6.真实带薪工作，移民前可收入3万加币，移民后继续就读高校可节省学费4万加币；
            </p>
            <p>
              7.生活成本低，曼省房租、水电、交通、保险等，均为全加最低。
            </p>
          </mdb-card-body>
        </mdb-col>
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/ca/6.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">申请流程</h4>
            <p>1.到嘉诚海外评估资质</p>
            <p>2.申请留学签证</p>
            <p>3.等待院校录取通知</p>
            <p>4.行程指导抵达加拿大</p>
            <p>5.入读相关学校</p>
            <p>6. 教育评估</p>
            <p>7. 申请工作许可</p>
            <p>8. 曼省省提名申请拿到枫叶卡</p>

          </mdb-card-body>
        </mdb-col>
      </mdb-row>
    </section>
  </mdb-container>
</template>

<script>
  export default {
    name: 'CaMan'
  }
</script>

<style scoped>

</style>
